/**
 * Выбор цветовой схемы — общий для приложений на одном origin (Front и админка): ключ localStorage и схема без явного
 * выбора (следовать системе). Те же значения читает блокирующий colorSchemeBootstrap.js до стилей.
 */
export const COLOR_SCHEME_STORAGE_KEY = 'bidzaar.colorScheme';
export const DEFAULT_COLOR_SCHEME = 'auto';
